export const SkeletonResume = () => (
  <div className="space-y-8 animate-pulse">
    {/* HEADER SKELETON */}
    <div className="flex items-center gap-3 border-b border-slate-200 dark:border-slate-800 pb-4">
      <div className="w-6 h-6 rounded-full bg-slate-200 dark:bg-slate-800" />
      <div className="space-y-2">
        <div className="h-6 w-48 bg-slate-200 dark:bg-slate-800 rounded" />
        <div className="h-4 w-72 bg-slate-200 dark:bg-slate-800 rounded" />
      </div>
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
      {/* KOLOM KIRI SKELETON */}
      <div className="lg:col-span-1 space-y-6">
        {/* Profile Card */}
        <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-6 flex flex-col items-center">
          <div className="w-32 h-40 rounded-lg bg-slate-200 dark:bg-slate-800 mb-4" />
          <div className="h-5 w-3/4 bg-slate-200 dark:bg-slate-800 rounded mb-2" />
          <div className="h-4 w-1/2 bg-slate-200 dark:bg-slate-800 rounded mb-3" />
          <div className="h-6 w-24 bg-slate-200 dark:bg-slate-800 rounded-full" />
        </div>
        {/* Biodata Card */}
        <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-5 space-y-4">
          <div className="h-5 w-32 bg-slate-200 dark:bg-slate-800 rounded mb-2" />
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="flex justify-between py-2 border-b border-slate-100 dark:border-slate-800"
            >
              <div className="h-4 w-24 bg-slate-200 dark:bg-slate-800 rounded" />
              <div className="h-4 w-32 bg-slate-200 dark:bg-slate-800 rounded" />
            </div>
          ))}
          <div className="pt-2">
            <div className="h-4 w-24 bg-slate-200 dark:bg-slate-800 rounded mb-2" />
            <div className="h-4 w-full bg-slate-200 dark:bg-slate-800 rounded mb-1" />
            <div className="h-4 w-2/3 bg-slate-200 dark:bg-slate-800 rounded" />
          </div>
        </div>
      </div>

      {/* KOLOM KANAN SKELETON */}
      <div className="lg:col-span-2 space-y-6">
        {/* Pilihan Prodi Card */}
        <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-6">
          <div className="h-6 w-48 bg-slate-200 dark:bg-slate-800 rounded mb-4" />
          <div className="space-y-3">
            {[1, 2].map((i) => (
              <div
                key={i}
                className="flex gap-3 items-center p-3 rounded-lg border border-slate-100 dark:border-slate-800"
              >
                <div className="w-8 h-8 rounded-full bg-slate-200 dark:bg-slate-800 shrink-0" />
                <div className="space-y-2 flex-1">
                  <div className="h-5 w-2/3 bg-slate-200 dark:bg-slate-800 rounded" />
                  <div className="h-4 w-1/4 bg-slate-200 dark:bg-slate-800 rounded" />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Nilai Rapor Card */}
        <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-6">
          <div className="h-6 w-32 bg-slate-200 dark:bg-slate-800 rounded mb-4" />
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
            {[1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                className="h-24 rounded-lg bg-slate-200 dark:bg-slate-800"
              />
            ))}
          </div>
        </div>

        {/* Berkas & Portofolio Card */}
        <div className="grid sm:grid-cols-2 gap-6">
          <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-6">
            <div className="h-6 w-40 bg-slate-200 dark:bg-slate-800 rounded mb-4" />
            <div className="space-y-2">
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  className="h-10 bg-slate-200 dark:bg-slate-800 rounded"
                />
              ))}
            </div>
          </div>
          <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-6">
            <div className="h-6 w-32 bg-slate-200 dark:bg-slate-800 rounded mb-4" />
            <div className="space-y-2">
              {[1, 2].map((i) => (
                <div
                  key={i}
                  className="h-10 bg-slate-200 dark:bg-slate-800 rounded"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
